(() => {
  'use strict';
  document.body.classList.add('se-custom-cursor');
  const crosshair = document.querySelector('[data-crosshair]');
  if (!crosshair) return;
  document.addEventListener('pointermove', (event) => {
    crosshair.style.left = `${event.clientX}px`;
    crosshair.style.top = `${event.clientY}px`;
  }, { passive: true });
})();
